/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseCourseidLanguagesId200,
  PutApiV1CourseCourseidLanguagesId400,
  PutApiV1CourseCourseidLanguagesId401,
  PutApiV1CourseCourseidLanguagesId404,
  PutApiV1CourseCourseidLanguagesId500,
  PutApiV1CourseCourseidLanguagesIdMutationRequest,
  PutApiV1CourseCourseidLanguagesIdMutationResponse,
  PutApiV1CourseCourseidLanguagesIdPathParams,
} from "../../types/courseLangsController/PutApiV1CourseCourseidLanguagesId.ts";
import { courseLangDetailViewModelSchema } from "../courseLangDetailViewModelSchema.ts";
import { courseLangEditorViewModelSchema } from "../courseLangEditorViewModelSchema.ts";

export const putApiV1CourseCourseidLanguagesIdPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CourseCourseidLanguagesId200Schema = z.lazy(
  () => courseLangDetailViewModelSchema,
) as unknown as ToZod<PutApiV1CourseCourseidLanguagesId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseCourseidLanguagesId400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseCourseidLanguagesId401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CourseCourseidLanguagesId404Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseCourseidLanguagesId500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesId500>;

export const putApiV1CourseCourseidLanguagesIdMutationRequestSchema = z.lazy(
  () => courseLangEditorViewModelSchema,
) as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdMutationRequest>;

export const putApiV1CourseCourseidLanguagesIdMutationResponseSchema = z.lazy(
  () => putApiV1CourseCourseidLanguagesId200Schema,
) as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdMutationResponse>;
